<template>
  <div>
    <ApprovalDocument
      :board="board"
      :value="form.body"

      @close="onClickClose"
      @delete="onClickDelete"
      @recall="onClickRecall"
      @print="onClickPrint"
      @tempsave="onClickTempsave"
      @retempsave="onClickReTempsave"
      @upload="onClickUpload"
      @ok="onClickOk"
      @no="onClickNo"
    >
      <template #header="props">
        <p class="h4 flex" style="align-items: center">
          저수조 위생 점검 기준
          <vs-input class="ml-8 mr-2" style="width:100px;" v-model="form.header.year" :readonly="true"/>년
          <vs-input class="ml-8 mr-2" style="width:100px;" v-model="form.header.month" :readonly="board.readonly"/>월
        </p>
      </template>

      <template #body="props">
        <div id="print">

          <!-- 기본정보 -->
          <m-group label="기본정보" :division="3">
            <m-form label="사업장명" :value="form.body.baseInfo.project_name" >
              <vs-input class="w-full" v-model="form.body.baseInfo.project_name" :readonly="true"/>
            </m-form>
            <m-form label="소속" :value="form.body.baseInfo.com_name" >
              <vs-input class="w-full" v-model="form.body.baseInfo.com_name" :readonly="true"/>
            </m-form>
            <m-form label="점검일자" :value="form.body.baseInfo.check_date" >
              <date-selector class="w-full" v-model="form.body.baseInfo.check_date" />
            </m-form>
            <m-form label="소유자(관리자)" :value="form.body.baseInfo.supervisor" >
              <vs-input class="w-full" v-model="form.body.baseInfo.supervisor"/>
            </m-form>
            <m-form label="점검담당자" :value="form.body.baseInfo.manager" >
              <vs-input class="w-full" v-model="form.body.baseInfo.manager"/>
            </m-form>
          </m-group>
          <m-group style="margin-top: 2rem;" label="건축물·설치정보" :division="1">
            <m-form label="건축물의 명칭" :value="form.body.buildingInfo.name">
              <vs-input class="w-1/2" v-model="form.body.buildingInfo.name"></vs-input></m-form>
            <m-form label="설치장소" :value="form.body.buildingInfo.place">
              <vs-input class="w-1/2" v-model="form.body.buildingInfo.place"></vs-input></m-form>
            <m-form label="건축물의 용도" :value="form.body.buildingInfo.purpose">
              <vs-input class="w-1/2" v-model="form.body.buildingInfo.purpose"></vs-input></m-form>
          </m-group>

          <!-- 점검항목 및 점검결과 -->
          <m-title style="margin-top: 2rem;" label="점검항목 및 점검결과" />
          <m-check-table
            title="구분"
            :menus="menuA"
            menu-width="128px"
          >
            <template v-slot:header>
              <check-table-header :division="1" title="점검기준" />
            </template>
            <template v-slot:default="{ menu }">
              <div style="display: grid; grid-template-columns: repeat(1, 1fr)">
                <check-table-body-item
                  v-for="work in form.body.check.checkListA[menu]"
                  :key="work.text"
                  :dataTypes="menuResults"
                  :value="work"
                  :is-print="isPrint"
                />
              </div>
            </template>
          </m-check-table>

          <!-- 첨부파일 -->
          <file-upload-module class="w-full" style="margin-top: 2rem;" v-model="fileList"></file-upload-module>
        </div>
      </template>

    </ApprovalDocument>
  </div>
</template>

<script>
import ApprovalDocument from '@/views/write/document/ApprovalDocument'
import Template from '@/views/admin/approval/Template'
import SafetyAccidentBasicData from '@/views/content/safety/SafetyAccidentBasicData'
import SafetyCheckBasicInfo from '@/views/write/safetycheck/components/SafetyCheckBasicInfo'
import MGroup from '@/components/base-ui/MGroup'
import MForm from '@/components/base-ui/MForm'
import MTitle from '@/components/base-ui/MTitle'
import MCheckTable from '@/components/base-ui/MCheckTable'
import FileUploadModule from '@/views/modules/FileUploadModule'
import DateSelector from '@/views/components/DateSelector'
import CheckTableBodyItem from '@/views/write/safetycheck/water_tank_hygiene_check/component/CheckTableBodyItem'
import CheckTableHeader from '@/views/write/safetycheck/water_tank_hygiene_check/component/CheckTableHeader'

export default {
  name: 'WaterTankHygieneCheck',
  components: {
    DateSelector,
    FileUploadModule,
    CheckTableBodyItem,
    CheckTableHeader,
    MCheckTable,
    MTitle,
    MForm,
    MGroup,
    SafetyCheckBasicInfo,
    SafetyAccidentBasicData,
    Template,
    ApprovalDocument},
  data () {
    return {
      isPrint: false,

      // TODO : 글쓰기 정보 및 권한
      board: {
        slug: this.boardSlug,
        statusCode: '', // 문서 상태코드
        writer: {}, //작성자 정보
        turnApprovalId: 0, // 결재자 ID
        readonly: false, // 읽기전용인가
        isWriter: true, // 작성자인가
        savable: true, // 임시저장이 가능하나
        isCompleteApproval: false, // 결재완료된 문서인가
        isTurnApproval: false, // 결재할 차례인가
        approvalLine: [], // 결재라인
        commentList: [] // 댓글리스트
      },

      form: {
        header: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1
        },
        body: {
          baseInfo: {
            project_name: this.projName,
            com_name: this.comName,
            supervisor: '',
            manager: '',
            workTypeTitleList: ['1. 저수조 주위의 상태', '2. 저수조 본체의 상태', '3. 저수조 윗부분의 상태', '4. 저수조 안의 상태', '5. 맨홀의 상태', '6. 월류관·통기관의 상태', '7. 냄새', '8. 맛', '9. 색도', '10. 탁도'],
            workType: [true, true, true, true, true, true, true, true, true, true],
          },
          buildingInfo: {
            name: '',
            place: '',
            purpose: ''
          },
          check: {
            checkListA: {
              '1. 저수조 주위의 상태': [
                {
                  text: '청결하며 쓰레기·오물 등이 놓여 있지 아니할 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
                {
                  text: '저수조 주위에 고인 물, 용수 등이 없을 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
              ],
              '2. 저수조 본체의 상태': [
                {
                  text: '균열 또는 누수되는 부분이 없을 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
                {
                  text: '출입구나 접합부의 틈으로 빗물 등이 들어가지 아니할 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
                {
                  text: '유출관·배수관 등의 접합부분은 고정되고 방수·밀폐되어 있을 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
              ],
              '3. 저수조 윗부분의 상태': [
                {
                  text: '저수조의 윗부분에는 물을 오염시킬 우려가 있는 설비나 기기 등이 놓여 있지 아니할 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
                {
                  text: '저수조의 상부는 물이 고이지 아니하여야 하고 먼지 등 위생에 해로운 것이 쌓이지 아니할 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
              ],
              '4. 저수조 안의 상태': [
                {
                  text: '오물, 붉은 녹 등의 침식물, 저수조 내벽 및 내부구조물의 오염 또는 도장의 떨어짐 등이 없을 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
                {
                  text: '수중 및 수면에 부유물질(浮游物質)이 없을 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
                {
                  text: '외벽도장이 벗겨져 빛이 투과하는 상태로 되어 있지 아니할 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
              ],
              '5. 맨홀의 상태': [
                {
                  text: '뚜껑을 통하여 먼지나 그 밖에 위생에 해로운 부유물질이 들어갈 수 없는 구조일 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
                {
                  text: '점검을 하는 자 외의 자가 쉽게 열고 닫을 수 없도록 잠금장치가 안전할 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
              ],
              '6. 월류관·통기관의 상태': [
                {
                  text: '관의 끝부분으로부터 먼지나 그 밖에 위생에 해로운 물질이 들어갈 수 없을 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
                {
                  text: '관 끝부분의 방충망은 훼손되지 아니하고 망눈의 크기는 작은 동물 등의 침입을 막을 수 있을 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
              ],
              '7. 냄새': [
                {
                  text: '물에 불쾌한 냄새가 나지 아니할 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
              ],
              '8. 맛': [
                {
                  text: '물이 이상한 맛이 나지 아니할 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
              ],
              '9. 색도': [
                {
                  text: '물에 이상한 색이 나타나지 아니할 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
              ],
              '10. 탁도': [
                {
                  text: '물에 이상한 탁함이 나타나지 아니할 것',
                  isAction: false,
                  data: {
                    '본관': false,
                    '옥상1': false,
                    '옥상2': false,
                    '의회': false
                  }
                },
              ],
            },
          }
        }
      },

      fileList: [],
      test: 'test',
    }
  },
  computed: {
    selectedWorkTypeList () {
      let selected = ''
      let count = 0
      for (let i = 0; i < this.form.body.baseInfo.workTypeTitleList.length; i++) {
        if (this.form.body.baseInfo.workType[i]) {
          if (count > 0) {
            selected += ', '
          }
          selected += this.form.body.baseInfo.workTypeTitleList[i]
          count++
        }
      }
      return selected
    },
    isUpdateMode () {
      return this.$route.params.postId
    },
    boardSlug () {
      return this.$route.params.boardSlug
    },
    projectId () {
      return parseInt(this.$route.params.proj_id)
    },
    menuA () {
      const menus = []
      for (let i = 0; i < this.form.body.baseInfo.workTypeTitleList.length; i++) {
        if (this.form.body.baseInfo.workType[i]) {
          menus.push(this.form.body.baseInfo.workTypeTitleList[i])
        }
      }
      return menus
    },
    menuResults () {
      return ['본관', '옥상1', '옥상2', '의회']
    },
    comName () {
      if (this.isUpdateMode) {

      } else {
        return this.$store.state.company.companyInfo.com_name;
      }
    },
    projName () {
      return this.$store.state.project.projectInfo.field_name;
    }
  },
  watch: {
    'comName' (value) {
      this.form.body.baseInfo.com_name = value;
    },
    'projName' (value) {
      this.form.body.baseInfo.project_name = value;
    }
  },
  mounted () {
    this.board.slug = this.boardSlug

    if (this.comName) {
      this.form.body.baseInfo.com_name = this.comName
    }
    if (this.projName) {
      this.form.body.baseInfo.project_name = this.projName
    }

    if (this.isUpdateMode) {
      this.loadPost()
    }
  },
  methods: {

    async loadPost () {
      const boardSlug = this.$route.params.boardSlug
      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/LOAD_POST', {
        boardSlug,
        postId
      })

      if (!this.$store.state.approval.postInfo) {
        alert('열람 권한이 없습니다.')
        this.oldForm = this.form
        this.$router.back()
        return
      }

      // 내용
      const post = JSON.parse(this.$store.state.approval.postInfo.post_content)
      this.form = post

      const files = this.$store.state.approval.postInfo.post_attachment
      if (files) {
        for (const file of files) {
          this.fileList.push({
            id: file.id,
            fileName: file.file_name,
            fileSize: file.file_size,
            path: file.path,
            thumb: file.thumb
          })
        }
      }

      // TODO : 결재프로세스
      await this.$store.dispatch('USER_INFO')
      const myId = this.$store.state.auth.userInfo.id
      const doc = this.$store.state.approval.document
      this.board.slug = this.boardSlug
      this.board.statusCode = doc.status.code
      this.board.writer = doc.writer
      this.board.turnApprovalId = doc.turn_approval_id
      this.board.isWriter = (this.board.writer.id === myId)
      this.board.isTurnApproval = (this.board.turnApprovalId === myId && (this.board.statusCode === 'registered' || this.board.statusCode === 'ongoing'))
      this.board.readonly = !(this.board.statusCode === 'temp' || this.board.statusCode === 'rejected')
      this.board.resend = (this.board.isWriter && this.board.statusCode === 'rejected')
      this.board.isCompleteApproval = (this.board.statusCode === 'approved' || this.board.statusCode === 'rejected')
      this.board.savable = this.board.isWriter && (this.board.statusCode === 'temp')
      this.board.collection = this.board.isWriter && (this.board.statusCode === 'registered')
      this.board.approvalLine = doc.line.slice() // 모듈 표기용
    },

    convertFileListToApiFiles () {
      let uploads = '[]'
      const uploadFileIds = []

      if (this.fileList && this.fileList.length > 0) {
        for (const file of this.fileList) {
          uploadFileIds.push(file.id)
        }
        uploads = JSON.stringify(uploadFileIds)
      }

      return uploads
    },

    getOptions (option) {
      const projectId = parseInt(this.$route.params.proj_id)

      const content = JSON.stringify(this.form)
      const uploads = this.convertFileListToApiFiles()

      return {
        projectId,
        content,
        uploads,
        ...option
      }
    },

    async sendUpload (option) {
      if (this.isUpdateMode) {
        const postId = parseInt(this.$route.params.postId)
        await this.$store.dispatch('approval/UPDATE_POST', {postId, unTemp:'y', ...this.getOptions(option)})
      } else {
        await this.$store.dispatch('approval/CREATE_POST', {...this.getOptions(option)})
      }
      alert('상신되었습니다.')
      this.onClickClose()
    },
    async sendTemp (option, isCreate) {
      // 임시 저장하기
      if (isCreate || !this.isUpdateMode) {
        await this.$store.dispatch('approval/CREATE_POST', {isTemp: 1, ...this.getOptions(option)})
      } else {
        const postId = parseInt(this.$route.params.postId)
        await this.$store.dispatch('approval/UPDATE_POST', {postId, unTemp: 'n', ...this.getOptions(option)})
      }
      alert('임시저장되었습니다.')
      this.onClickClose()
    },

    onChangeInput (value, files) {
      this.form.body = value
      this.fileList = files
    },

    onClickClose () {
      // 닫기
      this.$router.back()
    },
    async onClickDelete () {
      // 삭제
      if (confirm('삭제하시겠습니까?')) {
        const boardSlug = this.boardSlug
        const postId = this.$route.params.postId
        await this.$store.dispatch('approval/DELETE_POST', {boardSlug, postId})
        this.oldForm = this.form
        this.onClickClose()
      }
    },
    onClickPrint () {
      // 프린트
      this.isPrint = true
      this.$store.commit('ui/SET_IS_PRINT', true)

      setTimeout(() => {
        const g_oBeforeBody = document.getElementById('print').innerHTML
        const g_oBeforeApproval = document.getElementById('print-approval').innerHTML
        // 프린트를 보이는 그대로 나오기위한 셋팅
        window.onbeforeprint = function () {
          document.body.style.backgroundColor = '#fff'
          document.body.innerHTML = `${g_oBeforeBody}<br>${g_oBeforeApproval}`
        }
        window.print()
        location.reload()
      }, 300)
    },
    async onClickRecall (option) {
      // 결재문서 회수
      if (confirm('회수 후 임시저장 상태로 변경하시겠습니까?')) {
        await this.sendTemp(option)
      }
    },
    async onClickTempsave (option) {
      // 임시 저장하기
      await this.sendTemp(option)
    },
    async onClickReTempsave (option) {
      // 재상신
      await this.sendTemp(option, true)
    },
    async onClickUpload (option) {
      // 상신
      await this.sendUpload(option)
    },
    async onClickOk () {
      // 승인
      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/APPROVE_OK', {postId})
      this.onClickClose()
    },
    async onClickNo (text) {
      // 반려
      const postId = parseInt(this.$route.params.postId)
      const comment = text
      await this.$store.dispatch('approval/APPROVE_NO', { postId, comment })
      this.onClickClose()
    }
  }
}
</script>

<style scoped>

</style>
